import { HouseUserDTO } from '../../shared/DTO/UserDTO';

export class User {
    houseId: string;
    permissionRole: string;
    receiveReport: number;
    receivePush: number;
    receiveEmail: number;
    firstName: string;
    lastName: string;
    email: string;
    constructor(houseId: string, permissionRole: string, receiveReport: number, receivePush: number, receiveEmail: number,
        firstName: string, lastName: string, email: string) {
        this.houseId = houseId;
        this.permissionRole = permissionRole;
        this.receiveReport = receiveReport;
        this.receivePush = receivePush;
        this.receiveEmail = receiveEmail;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
    }
}

export class UserDetail {
    firstName: string;
    lastName: string;
    email: string;
    userId: string;
    creationDate: string;
    lastLogin: string;
    languageCode: string;
    identityId: string;
    constructor(firstName: string, lastName: string, email: string, userId: string,
        creationDate: string, lastLogin: string, languageCode: string, identityId: string) {
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.userId = userId;
        this.creationDate = creationDate;
        this.lastLogin = lastLogin;
        this.languageCode = languageCode;
        this.identityId = identityId;
    }
}

export class HouseUser {
    houseId: string;
    permissionRole: string;
    receiveReport: boolean;
    receivePush: boolean;
    receiveEmail: boolean;
    firstName: string;
    lastName: string;
    email: string;
    languageCode: string;
    constructor(houseId: string, permissionRole: string, receiveReport: boolean, receivePush: boolean, receiveEmail: boolean,
        firstName: string, lastName: string, email: string, languageCode: string) {
        this.houseId = houseId;
        this.permissionRole = permissionRole;
        this.receiveReport = receiveReport;
        this.receivePush = receivePush;
        this.receiveEmail = receiveEmail;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.languageCode = languageCode;
    }
}


export class ProfileUtils {
    private completeHouseCount: any = 0;
    totalHouseCount = 7;

    completeEntityTypeGroupsCount;
    totalEntityTypeGrousCount;

      getPercentage(n: number) {
        return Number(n).toFixed(0);
      }

      getHousePercentage() {
        const percentage = Number(this.getPercentage((this.completeHouseCount / this.totalHouseCount) * 100));

        return (isNaN(percentage) || Number.POSITIVE_INFINITY === percentage || Number.NEGATIVE_INFINITY === percentage) ? 0 : percentage;
      }

      getDevicesPercentage() {
        const percentage = Number((this.completeEntityTypeGroupsCount / this.totalEntityTypeGrousCount) * 100);

        return (isNaN(percentage) || Number.POSITIVE_INFINITY === percentage || Number.NEGATIVE_INFINITY === percentage) ? 0 : percentage;
      }
}



// WEBPACK FOOTER //
// ./src/app/entities/profile/profile.model.ts